export const LOAD_SETTINGS_FROM_STORAGE = "loadSettingsFromStorage";
export const TOGGLE_THEME_SETTING = "setTheme";
export const TOGGLE_DARK_MODE = "toggleDarkMode";
export const TOGGLE_BASELINE_SETTING = "setBaseline";
export const TOGGLE_MINMAX_SETTING = "setMinMax";
export const TOGGLE_UI_VISIBILITY = "setVisibility";
export const TOGGLE_DEFAULT_ANNOTATIONS_MODE = "changeDefaultAnnotationsMode";
export const TOGGLE_DEFAULT_ALL_NOTES_MODE = "toggleDefaultNotesMode";
export const EDIT_USER = "editUser";
export const UPDATE_COLUMN_SELECTION = "updateColumnSelection";
export const TOGGLE_STICKY_NAV_BAR = "toggleStickyNavBar";
export const TOGGLE_STRIPPED_ROWS = "toggleStrippedRows";
export const UPDATE_DEFAULT_SOURCES = "updateDefaultSources";
export const CHANGE_DRILLDOWN_VIEW_OPTIONS = "changeDrilldownViewOptions";
